import {updatePassword} from '../api/updatePassword';
import { putUpdatePaymentByUserId } from '../api/putUpdatePaymentByUserId';
import { setGetUserById } from './setGetUserById';
import { isFunction } from 'lodash';

export const setPutUpdatePaymentByUserId = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            await putUpdatePaymentByUserId(params);
            dispatch(setGetUserById(params?.user_id))
            if (isFunction(callback)) {
                callback();
            }
        } catch(error) {
            alert('Ошибка')
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}